module.exports = __webpack_public_path__ + "img/red-icon(2).319c3170.png";